import React, { ReactElement, useContext } from 'react'

import Heading from '../../Common/Components/Heading'
import Fieldset from '../../Common/Components/Fieldset'
import P from '../../Common/Components/P'
import { Select, SelectOptions } from '../../Common/Components/Selects'
import FormRow from '../../Common/Components/FormRow'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { CSVExportFormat as CSVExportFormatLanguage } from '../../../../i18n'
import {
    REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_ALTERNATIVE,
    REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_BOTH,
    REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_MAIN
} from './Constants'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'

/**
 * Component properties type.
 */
type Props = {
    formatCSVStatValuesType: number
    setFormatCSVStatValuesType: (newValue: number) => void
}

/**
 * CSV Export Format section in Advanced tab of report configuration modal window.
 *
 * @param statValuesType Report property.
 * @param setStatValuesType Setter for corresponding report property.
 */
const CSVExportFormat: React.FC<Props> = ({
    formatCSVStatValuesType,
    setFormatCSVStatValuesType
}: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('CSVExportFormat')

    const formatsOptions: SelectOptions<number> = [
        {
            value: REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_BOTH,
            label: language.get(CSVExportFormatLanguage.StatvaluestypeBothOptionLabel)
        },
        {
            value: REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_MAIN,
            label: language.get(CSVExportFormatLanguage.StatvaluestypeMainOptionLabel)
        },
        {
            value: REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_ALTERNATIVE,
            label: language.get(CSVExportFormatLanguage.StatvaluestypeAlternateOptionLabel)
        }
    ]

    return (
        <Fieldset className={'csv-export-format'}>
            <Heading level={HeadingLevel.ONE}>
                {language.get(CSVExportFormatLanguage.CSVExportFormat_SectionHeader)}
            </Heading>
            <P>{language.get(CSVExportFormatLanguage.CSVExportFormat_SectionPara)}</P>
            <FormRow isInline className={'format-csv-stat-values'}>
                <Select
                    label={language.get(CSVExportFormatLanguage.StatvaluestypeLabel)}
                    value={formatCSVStatValuesType}
                    handleChange={setFormatCSVStatValuesType}
                    options={formatsOptions}
                />
            </FormRow>
        </Fieldset>
    )
}

export default React.memo(CSVExportFormat)
